import { ChangeDetectionStrategy, Component, computed, inject, signal, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { PurchaseSummaryComponent } from '@components/purchase-summary/purchase-summary.component';
import { ProductItemCardComponent } from '@components/cards/product-item-card/product-item-card.component';
import { ShoppingCartState } from '../../states/shopping-cart-state';
import { EmptyShoppingCartCardComponent } from '@components/cards/empty-shopping-cart-card/empty-shopping-cart-card.component';
import { LnPrimaryButtonComponent } from '@components/butons/ln-primary-button/ln-primary-button.component';
import { MenuActions } from '../../states/menu_actions';
import { ShoppingCartProductDeletedComponent } from '@components/cards/shopping-cart-product-deleted/shopping-cart-product-deleted.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-shopping-car-body',
  imports: [
    NgClass,
    PurchaseSummaryComponent,
    ProductItemCardComponent,
    EmptyShoppingCartCardComponent,
    LnPrimaryButtonComponent,
    ShoppingCartProductDeletedComponent,
    TranslocoPipe,
  ],
  templateUrl: './shopping-car-body.component.html',
  styleUrl: './shopping-car-body.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShoppingCarBodyComponent {
  cartItemsSelected = signal(true);
  saveForLatterItems: WritableSignal<number> = signal(0);
  cardItemsCount = computed(() => this.shoppingCartState.shoppingCartItemsCount());
  cardItems = computed(() => this.shoppingCartState.shoppingCartItems());
  shoppingCartResumeSubtotal = computed(() => this.shoppingCartState.shoppingCartResumeSubtotal());
  existSinglePieceProduct = computed(() => this.shoppingCartState.existSinglePieceProduct());
  protected productDeletedFromCart = computed(() => this.shoppingCartState.productDeletedFromCart());
  private shoppingCartState = inject(ShoppingCartState);
  ToogleCartItemsSelected(shoppingCartItemsSelected: boolean) {
    this.cartItemsSelected.set(shoppingCartItemsSelected);
  }
  private menuActions = inject(MenuActions);
  goHome() {
    this.menuActions.goHome();
  }
}
